import Swiper from "swiper/bundle";

export default class SwiperHelper {
  constructor(
    params = {
      swiperSelector: ".swiper",
      swiperOptions: {},
    }
  ) {
    this.swiperSelector = params.swiperSelector;
    this.swiper = null;

    this.swiperOptions = params.swiperOptions;
  }

  init() {
    this.swiper = new Swiper(this.swiperSelector, {
      pagination: {
        el: `${this.swiperSelector} .swiper-pagination`,
      },

      navigation: {
        nextEl: `${this.swiperSelector} .swiper-button-next`,
        prevEl: `${this.swiperSelector} .swiper-button-prev`,
      },
      ...this.swiperOptions,
    });
  }
}
